import { useCallback, useEffect } from 'react'
import client from '../API'
import getHostMediaByHostId from '../screens/media/queries/getHostMediaByHostId'
import { useInterval } from './useInterval'
import { MediaStatusEnum, MediaTypeEnum } from '../types'

const pollIntervalMs = 45000

type HostMediaValue = {
  hostId?: string
  transcode?: string
  type?: string
} | null

export default function useHostMediaProcessingPoll(
  hostMedia: HostMediaValue | undefined,
  onUpdate: (media: Record<string, unknown>) => void
) {
  const shouldPoll =
    !!hostMedia?.hostId &&
    hostMedia?.type === MediaTypeEnum.Video &&
    hostMedia?.transcode === MediaStatusEnum.Processing

  const poll = useCallback(async () => {
    if (!hostMedia?.hostId) return

    try {
      const result = await client.query({
        query: getHostMediaByHostId,
        variables: { hostId: hostMedia.hostId },
        fetchPolicy: 'network-only'
      })

      const updated = result?.data?.hostMediaByHostId
      if (updated && updated.transcode !== MediaStatusEnum.Processing) {
        onUpdate(updated)
      }
    } catch {
      // Ignore transient poll failures; next interval will retry.
    }
  }, [hostMedia?.hostId, onUpdate])

  useEffect(() => {
    if (shouldPoll) {
      poll()
    }
  }, [shouldPoll, poll])

  useInterval(poll, shouldPoll ? pollIntervalMs : null)
}
